module.exports = __webpack_public_path__ + "img/A_A_Certificate.ec7da7a6.jpg";